const _version = "3.8.9"
function version() {
    return _version
}
export default version
